module.exports = __webpack_public_path__ + "img/user-icon.54320b60.svg";